import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classes from './ManagerLogin.module.css';
import strings from '../../../../globalization';
import activateArrow from '../../../../assets/images/login/activateArrow.png';
import { oneDineLogo } from '../../../../assets/images';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';

const ManagerLogin = ({ onLoginPress, closePopup, indentifier }) => {
  const [fieldValue, setFieldValue] = useState('');

  const loginHandler = () => {
    onLoginPress && onLoginPress(fieldValue, indentifier);
    setFieldValue('');
  };

  return (
    <div className={classes.container}>
      <div className={classes.backButton} onClick={closePopup}>
        <img src={backImg} className={classes.backImage} alt="" />
      </div>
      <img src={oneDineLogo} className={classes.logo} alt="logo" />
      <div className={classes.wrapper}>
        <div className={classes.heading}>{strings.enterYourLoginId}</div>
      </div>
      <div className={classes.btnWrapper}>
        <input type="text" placeholder="" value={fieldValue} onChange={event => setFieldValue(event.target.value)} className={classes.textInput} />
        <button type="submit" onClick={loginHandler}>
          <img src={activateArrow} className={classes.activate} alt="activateArrow" />
        </button>
      </div>
    </div>
  );
}

export default ManagerLogin;

ManagerLogin.propTypes = {
  onLoginPress: PropTypes.func.isRequired,
  closePopup: PropTypes.func.isRequired,
  indentifier: PropTypes.string,
};

ManagerLogin.defaultProps = {
  onLoginPress: () => { },
  closePopup: () => { },
  indentifier: '',
};
